import { FC, JSX, useMemo } from 'react';

import { StylesConfig } from '@player/content';

import PositionCenter from '@/shared/ui/icons/svgs/24/position-center.svg?react';
import PositionDown from '@/shared/ui/icons/svgs/24/position-down.svg?react';

import ToggleButton from './ToggleButton';

enum TextPosition {
  Bottom = 'bottom',
  Center = 'center',
}

interface IPositionSwitcherProps {
  position?: StylesConfig['text']['position'];
  onChange: (position: StylesConfig['text']['position']) => void;
}

const PositionSwitcher: FC<IPositionSwitcherProps> = ({
  position = TextPosition.Bottom,
  onChange,
}): JSX.Element => {
  const isBottomActive = useMemo(
    () => position === TextPosition.Bottom,
    [position]
  );
  const isCenterActive = useMemo(
    () => position === TextPosition.Center,
    [position]
  );
  const onToggleChange = (active: boolean, pos: TextPosition) => {
    onChange?.(active ? pos : TextPosition.Bottom);
  };

  return (
    <>
      <ToggleButton
        Icon={PositionDown}
        className="pb-2 pt-6"
        tooltip="Bottom"
        active={isBottomActive}
        onChange={(active) => onToggleChange(active, TextPosition.Bottom)}
      />
      <ToggleButton
        Icon={PositionCenter}
        tooltip="Center"
        active={isCenterActive}
        onChange={(active) => onToggleChange(active, TextPosition.Center)}
      />
    </>
  );
};

export default PositionSwitcher;
